import React, { useState } from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'

import Image from '../../atoms/Image'
import { MysqlProducts } from '../../graphqlTypes'

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
`

const Prev = styled.div`
  cursor: pointer;
  margin: 0 20px 0 0;
  width: 24px;
  height: 24px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0 10px 0 30px;
    width: 32px;
    height: 32px;
  }
`

const ImageFrame = styled.div`
  width: 250px;
  height: 250px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 320px;
    height: 320px;
  }
`

const ProductImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const Next = styled.div`
  cursor: pointer;
  margin: 0 0 0 20px;
  width: 24px;
  height: 24px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0 30px 0 10px;
    width: 32px;
    height: 32px;
  }
`

const ThumbnailList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  margin: 12px 16px 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 30px auto 0;
  }
`

const ThumbnailItem = styled.li<{ active: boolean }>`
  border: 1px solid ${({ active, theme }) => (active ? theme.palette.primary.light : theme.palette.border.light)};
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 0 0 13px;
  padding: 1px;
  width: 44px;
  height: 44px;
  &:first-child {
    margin-left: 0;
  }
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0 0 0 15px;
    width: 50px;
    height: 50px;
  }
`

type Props = {
  product: MysqlProducts
}

export default function ProductImageList({ product }: Props) {
  const [activeThumbIndex, setActiveThumbIndex] = useState(0)

  // imageを先頭にsecondary_imagesとconcatする
  const imageUrls: string[] = [
    product.fields!.imageUrl!,
    ...(product.secondary_images ? JSON.parse(product.secondary_images) : []).map(
      (image: string) => `${process.env.GATSBY_CDN_URL}/2019_autumn/product/${image}`
    )
  ]

  // 画像がなければスライダーは表示しない
  const showSlider = imageUrls.length > 1

  return (
    <React.Fragment>
      <Container>
        {showSlider && (
          <Prev onClick={() => setActiveThumbIndex((activeThumbIndex === 0 ? imageUrls.length : activeThumbIndex) - 1)}>
            <Image alt="戻る" filename="icon-prev.png" />
          </Prev>
        )}
        <ImageFrame>
          <LazyLoadComponent>
            <ProductImage
              alt={`${product.name} ${activeThumbIndex + 1}枚目`}
              src={`${imageUrls[activeThumbIndex]}?auto=format`}
            />
          </LazyLoadComponent>
        </ImageFrame>
        {showSlider && (
          <Next
            onClick={() => setActiveThumbIndex(activeThumbIndex === imageUrls.length - 1 ? 0 : activeThumbIndex + 1)}
          >
            <Image alt="進む" filename="icon-next.png" />
          </Next>
        )}
      </Container>
      {showSlider && (
        <ThumbnailList>
          {imageUrls.map((imageUrl, index) => (
            <ThumbnailItem active={activeThumbIndex === index} key={index} onClick={() => setActiveThumbIndex(index)}>
              <ProductImage alt={`${product.name} ${index + 1}枚目`} src={`${imageUrl}?auto=format`} />
            </ThumbnailItem>
          ))}
        </ThumbnailList>
      )}
    </React.Fragment>
  )
}
